var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-dashboard"},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"wrap-content"},[_c('div',{staticClass:"welcome-container"},[_c('h1',[_vm._v("Welcome, "+_vm._s(_vm.username)+" !")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }